import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const OverLayLoader = styled("div")(({ theme }) => ({
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colorMode === "light" ? "#FFFBF7" : theme.colors.dark.canvas_Primary,
}));

export const OverLayLoaderContent = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing.medium,
}));

export const OverLayLoaderText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
}));

export const OverLayLoaderText2 = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
    color: theme.colors[theme.colorMode].text_Low_Emphasis,
}));
